import React from "react";
import { useTranslation } from "i18n";
import { MediaType } from "shared-types";
import {
  MediaTimeIcon as ProcessingIcon,
  MediaPlaySkinnyIcon,
  SonicWaveImage,
  WarningBaseIcon,
} from "assets";
import "./ThumbnailVideoViewer.scss";

export interface IThumbnailVideoViewerProps {
  title?: string;
  playback: () => void;
  thumbnailUrl?: string;
  isLoaded: boolean;
  mediaType?: MediaType;
  isProcessingVisible?: boolean;
  isUnavailable?: boolean;
}

export const ThumbnailViewer: React.FC<
  React.PropsWithChildren<IThumbnailVideoViewerProps>
> = ({
  title,
  playback,
  thumbnailUrl,
  mediaType,
  isLoaded,
  isProcessingVisible = true,
  isUnavailable = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="c-thumbnail-video-viewer">
      <div className="c-thumbnail-video-viewer__preview">
        {!isLoaded && !isUnavailable && isProcessingVisible && (
          <div className="c-thumbnail-video-viewer__loading">
            <div className="c-thumbnail-video-viewer__loading-cover">
              <ProcessingIcon />
              {t("common:label.processing")}
            </div>
          </div>
        )}
        {isUnavailable && (
          <div className="c-thumbnail-video-viewer__loading">
            <div className="c-thumbnail-video-viewer__loading-cover">
              <WarningBaseIcon className="c-thumbnail-video-viewer__unavailable-icon" />
              <div className="c-thumbnail-video-viewer__unavailable-message">
                {t("common:label.mediaError")}
              </div>
            </div>
          </div>
        )}
        {isLoaded && (
          <div className="c-thumbnail-video-viewer__cover" onClick={playback}>
            <img
              src={
                mediaType === MediaType.Video ? thumbnailUrl : SonicWaveImage
              }
              alt={title}
            />
            <MediaPlaySkinnyIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default ThumbnailViewer;
